import React, { memo, useCallback } from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import NavDrawerToggleButton from "features/drawer/components/NavDrawerToggleButton";
import MobileSearch from "features/searchBar/MobileSearch";
import { useNavigate } from "react-router-dom";

const MobileHeader = () => {
  const navigate = useNavigate();
  const navigateHome = useCallback(() => {
    navigate("/");
  }, []);
  return (
    <Container>
      <Left>
        <NavDrawerToggleButton />
      </Left>
      <Center className="center" onClick={navigateHome}>
        <Logo src="/logo_mobile.png" />
      </Center>
      <Right>
        <MobileSearch />
      </Right>
    </Container>
  );
};

export default memo(MobileHeader);
const Container = styled.div`
  display: flex;
  width: 100%;
  height: ${toRem(50)};
  background-color: black;
  z-index: 90;
  position: sticky;
  top: 0;
  transition: all 0.2s ease-in-out;
  transform: translateY(0);
`;

const Left = styled.div`
  flex: 0 1 50%;
`;

const Right = styled.div`
  display: flex;
  flex: 0 1 50%;
  justify-content: flex-end;
  align-items: center;
  align-items: right;
`;

const Center = styled.div`
  display: flex;
  flex: 0 1 50%;
  justify-content: center;
  align-items: center;
  height: 80%;
  align-self: center;
`;

const Logo = styled.img`
  max-width: 70%;
  max-height: 70%;
  display: block;
`;

export const MenuIcon = styled.div`
  height: 100%;
  width: ${toRem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
`;
